/**
 * Sticky-note edit entry rules for the inspiration board.
 *
 * Selecting a note must NOT enter edit mode: TipTap interactive surfaces use
 * React Flow's `nodrag` class, which would block dragging if applied over the
 * whole sticky. Edit starts on double-click (or when a brand-new empty note
 * mounts already selected). While editing, a drag chrome/handle stays free of
 * `nodrag` so the note can still be repositioned (CRM #28 / #31).
 */
export function initialNoteEditing(opts: {
  selected: boolean;
  readOnly: boolean;
  text?: string;
  textHtml?: string;
}): boolean {
  if (opts.readOnly || !opts.selected) return false;
  const hasText = Boolean((opts.text && opts.text.length > 0) || (opts.textHtml && opts.textHtml.length > 0));
  return !hasText;
}

export function shouldKeepNoteEditing(opts: {
  selected: boolean;
  multiSelected: boolean;
  dragging?: boolean;
}): boolean {
  if (opts.dragging) return false;
  return opts.selected && !opts.multiSelected;
}
